/* (ignored) */


//////////////////
// WEBPACK FOOTER
// fs (ignored)
// module id = 0
// module chunks = 3